/**

    * Application Name: Zevcore unolo Backend
    * Application Version: 1.0
    * Author: Zevcore Private Limited
    * Created Date: 17.05.2023
    * Last Modified Date: 17.05.2023
    * Developer Name: Anand_Krishna

**/

import { url } from "../../../services/url";
import axios from "axios";

export const MeetingImage_Url = `${url.baseUrl}public/images/meetings/`;

const fetchCredentials = async () => {
  try {
    // Retrieve the credentials
    const credentials = await localStorage.getItem("token");
    if (credentials) {
      return {
        headers: {
          "x-access-token": credentials,
        },
      };
    } else {
      console.log("No credentials stored");
    }
  } catch (error) {
    console.log("Keychain couldn't be accessed!", error);
  }
  return false;
};

const dashboardUrl = {
  dashboard_Url: `${url.apiUrl}/dashboard`,
  meeting_Url: `${url.apiUrl}/meetings`,
};

// For handle get Location Type data list
export const handleGetAllData = async (request) => {
  try {
    const config = await fetchCredentials();
    const response = await axios.get(dashboardUrl.dashboard_Url, config);
    return response;
  } catch (error) {
    return error.response;
  }
};

// For handle delete Location Type data list
export const handleDeleteMeeting = async (request) => {
  try {
    const config = await fetchCredentials();
    const response = await axios.delete(
      dashboardUrl.meeting_Url + "/" + request,
      config
    );
    return response;
  } catch (error) {
    return error.response;
  }
};
